import { StackScreenProps } from "@react-navigation/stack";
import { ActionCreateQuoteSaleRootParamList } from "../../../../types";
import { Button, Page, Stack } from "@towersystems/roam-common-native";
import { CustomerCard } from "../../components/CustomerCard";
import { useTranslation } from "../../../../utilities/i18n";
import { Colors } from "react-native-ui-lib";
import {
  useParkSale,
  useSaleControllerProvider,
} from "../../utils/sale-controller";
import React from "react";
import { SaleState } from "../../../../utilities/data/model/Sale";
import { ActionCreateQuoteSaleRootScreenProps } from "../ActionCreateQuoteSaleRootScreen";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";

export interface ConfirmQuoteDetailsScreenProps
  extends StackScreenProps<
    ActionCreateQuoteSaleRootParamList,
    "ConfirmQuoteDetailsScreen"
  > {}

export const ConfirmQuoteDetailsScreen = ({
  navigation,
  route,
}: ConfirmQuoteDetailsScreenProps) => {
  const { sale, createEmptySale } = useSaleControllerProvider();
  const { t } = useTranslation("pos");
  const { customerId } = route.params;
  const parkSale = useParkSale();

  const handleOnCreateQuote = React.useCallback(async () => {
    try {
      if (sale) {
        await parkSale();
      }
      const newSale = await createEmptySale();
      await newSale.addCustomer(customerId);
      await newSale.transitionToState(SaleState.QUOTE_OPEN);
      // The parent will be nested within a stack navigator,
      // so we need to pop twice to go back to the previous screen
      navigation
        .getParent<ActionCreateQuoteSaleRootScreenProps["navigation"]>()
        .getParent<NativeStackNavigationProp<any>>()
        .pop();
    } catch (err) {}
  }, [sale]);

  const footerMarkup = (
    <Button
      disabled={false}
      label={t("button.create_quote")}
      onPress={handleOnCreateQuote}
      backgroundColor={Colors.action}
      color="white"
    ></Button>
  );

  return (
    <Page title={t("quote_details")} footer={footerMarkup}>
      <Stack vertical>
        <CustomerCard customerId={customerId} />
      </Stack>
    </Page>
  );
};
